module.exports = __webpack_public_path__ + "img/電気回路_3_5_2.9308f9e5.png";